"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminToolsTabContent = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_select_1 = require("react-select");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var userSettingsActions = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var constants_1 = require("utils/constants");
var timeout = null;
var mapStateToProps = function (state) {
    return {
        isOpen: state.user.userSettings.isOpen,
        user: state.user.userSettings.user,
        company: state.user.userSettings.company,
        customers: state.user.userSettings.customers,
        newEmail: state.user.userSettings.newEmail
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    resetPassword: function (user) { return function () {
        var _a;
        return dispatch(userSettingsActions.resetPasswordRequest(user.id, user.email, (_a = user.language) !== null && _a !== void 0 ? _a : 'en'));
    }; },
    resendAuthenticationCode: function (user) { return function () {
        return dispatch(userSettingsActions.resendAuthenticationCodeRequest(user.id, user.email));
    }; },
    removeUser: function (user) { return function () {
        return dispatch(userSettingsActions.removeUserRequest(user.uuid));
    }; },
    setCustomer: function (customer) {
        return dispatch(userSettingsActions.setCustomer(Array.isArray(customer) ? undefined : customer));
    },
    fetchCustomers: function (company) {
        if (company !== '') {
            dispatch(userSettingsActions.fetchCustomers(company));
        }
    },
    setNewEmail: function (newEmail) {
        return dispatch(userSettingsActions.setNewEmail(newEmail));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('tempValue', 'setTempValue', null), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.isOpen) {
            if (this.props !== nextProps) {
                return true;
            }
        }
        return false;
    }
}), recompose_1.pure);
exports.AdminToolsTabContent = enhance(function (props) {
    return (React.createElement("div", { className: 'admin-tab' }, props.user.fold(React.createElement("div", null), function (user) { return (React.createElement(sok_ui_1.Grid.Row, null,
        React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12, small: 4 },
            React.createElement("div", null,
                React.createElement("strong", null, (0, translation_1.getLocalization)('userSettingsModal/step3/companyName'))),
            React.createElement(react_select_1.default, { menuPlacement: 'auto', classNamePrefix: 'react-select', id: 'companyName', placeholder: (0, translation_1.getLocalization)('userSettingsModal/step3/searchCompanyName'), value: props.company, options: props.customers, isSearchable: true, getOptionValue: function (opt) { return opt.name; }, getOptionLabel: function (opt) { return opt.name; }, onChange: props.setCustomer, onInputChange: props.fetchCustomers, isDisabled: !!props.newEmail }),
            React.createElement(sok_ui_1.TextInput, { className: 'white', placeholder: (0, translation_1.getLocalization)('userSettingsModal/step3/newEmail'), value: props.tempValue === null ? props.newEmail : props.tempValue, disabled: !!props.company, onChange: function (e) {
                    var value = e.target.value;
                    props.setTempValue(value);
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = setTimeout(function () {
                        props.setNewEmail(value);
                        props.setTempValue(null);
                    }, constants_1.SEARCH_TIMEOUT);
                } })),
        React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12, small: 4 },
            React.createElement("div", null,
                React.createElement("strong", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication'))),
            user.federated ? (React.createElement("div", { className: 'federated-user' }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication/notification'))) : (React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { className: 'full-width', color: 'dark-gray', icon: React.createElement(Icon_1.Icon, { className: 'fa-lock' }), onClick: props.resetPassword(user), disabled: user.status === 'FIRST_TIME' }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication/buttons/resetPassword')),
                React.createElement(sok_ui_1.Button, { className: 'full-width', color: 'dark-blue', icon: React.createElement(Icon_1.Icon, { className: 'fa-key' }), onClick: props.resendAuthenticationCode(user) }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication/buttons/resendAuthenticationCode')))),
            React.createElement(sok_ui_1.Button, { className: 'full-width', color: 'blue', icon: React.createElement(Icon_1.Icon, { className: 'fa-user' }) }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication/buttons/logAsUser'))),
        React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12, small: 4 },
            React.createElement("div", null,
                React.createElement("strong", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/account'))),
            React.createElement(sok_ui_1.Button, { className: 'full-width', color: 'green', icon: React.createElement(Icon_1.Icon, { className: 'fa-file-pdf' }) }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication/buttons/generateReport')),
            React.createElement(sok_ui_1.Button, { className: 'full-width', color: 'purple', icon: React.createElement(Icon_1.Icon, { className: 'fa-unlock' }) }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication/buttons/deactiveAccount')),
            React.createElement(sok_ui_1.Button, { className: 'full-width', color: 'red', icon: React.createElement(Icon_1.Icon, { className: 'fa-trash' }), onClick: props.removeUser(user) }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTab/column/authentication/buttons/deleteAccount'))))); })));
});
